export const discoveryTranslations = {
  de: {
    "discover.navigation": "Reiseideen",
    "discover.surprise": "Surprise Me",
    "discover.weekend": "Weekend Finder",
    "discover.surpriseTitle": "Dein nächstes Ziel? Eine Überraschung.",
    "discover.weekendTitle": "Kurz raus. Viel erleben.",
    "discover.surpriseIntro": "Wir suchen direkt nach einem Ziel für deine nächste kleine Auszeit. Du musst nur noch die Koffer packen.",
    "discover.weekendIntro": "Ein freies Wochenende reicht. Entdecke passende Hin- und Rückflüge für deine nächste Auszeit.",
    "discover.departingFrom": "Ab",
    "discover.surpriseDefaults": "Nächste 8 Wochen · 2–5 Nächte · Direkt hin & zurück",
    "discover.when": "Wann möchtest du los?",
    "discover.weeks": "Nächste {count} Wochen",
    "discover.weekendStyle": "Wie sieht dein Wochenende aus?",
    "discover.friSunName": "Der Klassiker",
    "discover.satSunName": "Ganz spontan",
    "discover.friMonName": "Etwas länger",
    "discover.friSunShort": "Fr – So",
    "discover.satSunShort": "Sa – So",
    "discover.friMonShort": "Fr – Mo",
    "discover.oneNight": "1 Nacht",
    "discover.nights": "{count} Nächte",
    "discover.change": "Ändern",
    "discover.rolling": "Dein nächstes Abenteuer wird gewürfelt …",
    "discover.rollingHint": "Wohin geht’s wohl diesmal?",
    "discover.reroll": "Nochmal würfeln",
    "discover.find": "Mein Wochenende finden",
    "discover.loading": "Passende Flüge werden gesucht …",
    "discover.retry": "Erneut suchen",
    "discover.error": "Die Flugsuche ist gerade nicht erreichbar. Bitte versuche es erneut.",
    "discover.empty": "Hier war noch kein passender Flug dabei.",
    "discover.emptyHint": "Probiere einen längeren Zeitraum oder ein anderes Wochenende.",
    "discover.surpriseEmpty": "Für deinen Abflugort haben wir gerade keine passenden Direktflüge gefunden. Du kannst den Abflugort auf der Startseite ändern.",
    "discover.results": "{count} passende Flüge · Günstigste zuerst",
    "discover.yourPick": "Dein nächstes Abenteuer",
    "discover.choices": "{count} Reiseziele entdeckt",
    "discover.onlyOne": "Aktuell haben wir ein passendes Reiseziel für dich gefunden.",
    "discover.more": "Weitere Flüge anzeigen",
    "discover.scope": "Direktflüge · Hin & zurück · Günstigste zuerst",
    "discover.travelPreferences": "Deine gespeicherten Einreise-Einstellungen werden berücksichtigt.",
  },
  en: {
    "discover.navigation": "Travel ideas",
    "discover.surprise": "Surprise Me",
    "discover.weekend": "Weekend Finder",
    "discover.surpriseTitle": "Your next stop? A surprise.",
    "discover.weekendTitle": "A little escape. A lot to discover.",
    "discover.surpriseIntro": "We’re finding a destination for your next little escape. All you need to do is pack.",
    "discover.weekendIntro": "One free weekend is all it takes. Find return flights for your next little escape.",
    "discover.departingFrom": "From",
    "discover.surpriseDefaults": "Next 8 weeks · 2–5 nights · Direct return flights",
    "discover.when": "When would you like to go?",
    "discover.weeks": "Next {count} weeks",
    "discover.weekendStyle": "What’s your kind of weekend?",
    "discover.friSunName": "The classic",
    "discover.satSunName": "A quick escape",
    "discover.friMonName": "A little longer",
    "discover.friSunShort": "Fri – Sun",
    "discover.satSunShort": "Sat – Sun",
    "discover.friMonShort": "Fri – Mon",
    "discover.oneNight": "1 night",
    "discover.nights": "{count} nights",
    "discover.change": "Change",
    "discover.rolling": "Rolling your next adventure …",
    "discover.rollingHint": "Where will you land this time?",
    "discover.reroll": "Roll again",
    "discover.find": "Find my weekend",
    "discover.loading": "Finding matching flights …",
    "discover.retry": "Search again",
    "discover.error": "Flight search is temporarily unavailable. Please try again.",
    "discover.empty": "No matching flights this time.",
    "discover.emptyHint": "Try a longer date range or a different weekend style.",
    "discover.surpriseEmpty": "We couldn’t find matching direct flights from your departure airport right now. You can change your departure airport on the home page.",
    "discover.results": "{count} matching flights · Cheapest first",
    "discover.yourPick": "Your next adventure",
    "discover.choices": "{count} destinations discovered",
    "discover.onlyOne": "We’ve found one matching destination for you right now.",
    "discover.more": "Show more flights",
    "discover.scope": "Direct flights · Return trip · Cheapest first",
    "discover.travelPreferences": "Your saved entry requirement preferences apply.",
  },
};
